<script>
export default {
  name: "ManageJobTitles",
  data() {
    return {
      navOpen: false,
      jot: {
        title: '',
        code: '',
        department: '',
        departmentTitle: ''
      },
      jottitle: '',
      jotcode: '',
      posDep: '',
      selectedDepName: '',
      selectedDep: '',
      listJoT: '',
      search: '',
      editingJoT: {},
    }
  },
  computed: {
    filteredJot() {
      if (!this.search) {
        return this.listJoT;
      }
      return this.listJoT.filter(jot => jot.title.toLowerCase().includes(this.search.toLowerCase()));
    }
  },
  methods: {
    async regChangesJoT() {
      try {
        let data = {
          title: this.editingJoT.title,
          dep: this.editingJoT.department
        }
        let result = await this.$api.put(`/auth/jobs/${this.editingJoT.id}`, data, {
          headers: {'Content-Type': 'application/x-www-form-urlencoded'}
        });

        if (result.status.toString() === "201") {
          this.$swal.fire({
            icon: 'success',
            title: 'Se han guardado los cambios',
            text: '',
            customClass: {
              popup: 'mySwal'
            }
          })
          this.editingJoT = {};

          await this.getJoTAll()
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'No se han podido registrar los cambios',
            text: '',
            customClass: {
              popup: 'mySwal'
            }
          })
          await this.getJoTAll()
        }
      } catch (error) {
        this.$swal.fire({
          icon: 'error',
          title: 'No se han podido registrar los cambios',
          text: '',
          customClass: {
            popup: 'mySwal'
          }
        })
      }
    },
    async regJoT() {
      try {
        let data = {
          title: this.jot.title, code: this.jot.code, dep: this.jot.department
        }
        let result = await this.$api.post("/auth/jobs", data, {
          headers: {'Content-Type': 'application/x-www-form-urlencoded'}
        });

        if (result.status.toString() === "201") {
          this.$swal.fire({
            icon: 'success',
            title: 'Se han guardado los cambios',
            text: '',
            customClass: {
              popup: 'mySwal'
            }
          });
          this.jot.title = '';
          this.jot.code = '';
          this.jot.department = '';
          this.jot.departmentTitle = '';
          await this.getJoTAll()
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'No se han podido registrar los cambios',
            text: '',
            customClass: {
              popup: 'mySwal'
            }
          });
        }
      } catch (error) {
        this.$swal.fire({
          icon: 'error',
          title: 'No se han podido registrar los cambios',
          text: '',
          customClass: {
            popup: 'mySwal'
          }
        })
      }
    },
    async getDep() {
      try {
        let result = await this.$api.get("/auth/departments")
        if (result.status.toString() === "200") {
          this.posDep = result.data
          for (let i = 0; i < this.posDep.length; i++) {
            let temp = this.posDep[i].id
            for (let j = i + 1; j < this.posDep.length; j++) {
              if (temp === this.posDep[j].id) {
                this.posDep[i].child = this.posDep[i].child + " | " + this.posDep[j].child
                this.posDep.splice(j, 1)
                j--
              }
            }
          }
        }
      } catch (error) {
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'No se pudo obtener informacion requerida',
          customClass: {
            popup: 'mySwal'
          }
        })
      }
    },
    getIDDep() {
      let selectedItem = this.posDep.find(dep => dep.title === this.jot.departmentTitle);
      if (selectedItem !== undefined) {
        this.jot.department = selectedItem.id
      } else {
        this.jot.department = 0
      }
    },
    getIDDepEdit() {
      let selectedItem = this.posDep.find(dep => dep.title === this.editingJoT.departmentTitle);
      if (selectedItem !== undefined) {
        this.editingJoT.department = selectedItem.id
      } else {
        this.editingJoT.department = 0
      }
    },
    async getJoTAll() {
      let result = await this.$api.get("/auth/jobs")
      if (result.status.toString() === "200") {
        this.listJoT = result.data
      }
    },
    editJoT(JoT) {
      this.editingJoT = JoT
    },
    cancelEdit() {
      this.editingJoT = ''
    },
    inputLimiterSearch() {
      this.search = this.search.replace(/[^a-z0-9 ]/gi, '').trimStart();
    },
    inputLimiterTitle() {
      this.jot.title = this.jot.title.replace(/[^a-z0-9 ]/gi, '').trimStart();
    },
    inputLimiterCode() {
      this.jot.code = this.jot.code.replace(/[^a-z0-9 ]/gi, '').trimStart();
    },
    inputLimiterDep() {
      this.jot.departmentTitle = this.jot.departmentTitle.replace(/[^a-z0-9 ]/gi, '').trimStart();
    },
    inputLimiterTitleEdit() {
      this.editingJoT.title = this.editingJoT.title.replace(/[^a-z0-9ñÑ ]/gi, '').trimStart();
    },
    inputLimiterDepEdit() {
      this.editingJoT.departmentTitle = this.editingJoT.departmentTitle.replace(/[^a-z0-9 ]/gi, '').trimStart();
    },
  },
  created() {
    this.getDep()
    this.getJoTAll()
  }
}

</script>

<template>


  <h1>Puesto de trabajo</h1>

  <div class="grid-container-left">
    <div>

      <form class="Form">
        <input type="text" v-model="search" v-on:input="inputLimiterSearch"
               placeholder="Buscar puesto de trabajo">
      </form>
      <div class="container mt-4 table-container" v-if="listJoT">
        <table class="table table-bordered">
          <thead>
          <tr>
            <th>#</th>
            <th>Titulo</th>
            <th>Codigo</th>
            <th>Departamento</th>
            <th>Usuario</th>
            <th>Accion</th>

          </tr>

          </thead>
          <tbody>

          <tr v-for="(jot, index) in filteredJot" :key="jot.id">
            <th scope="row">{{ index + 1 }}</th>
            <td>{{ jot.title }}</td>
            <td>{{ jot.code }}</td>
            <td>{{ jot.departmentTitle }}</td>
            <td>{{ jot.firstname }} {{ jot.lastname }}</td>
            <td class="td_align_center">
              <button class="tableBtn" @click="editJoT(jot)" role="link">Editar</button>
            </td>
          </tr>

          </tbody>

        </table>
      </div>

      <div v-if="!listJoT.length">
        <label>No se encontraron departamentos</label>
      </div>

    </div>


    <div>

      <div v-if="!editingJoT">
        <h2>Registrar puesto de trabajo</h2>
        <form class="Form">
          <label>Titulo</label>
          <input type="text" v-model="jot.title" v-on:input="inputLimiterTitle"
                 placeholder="Titulo del puesto de trabajo">
          <label>Codigo de Puesto</label>
          <input type="text" v-model="jot.code" v-on:input="inputLimiterCode"
                 placeholder="Codigo del puesto">
          <label>Departamento</label>
          <input list="posDep" v-model="jot.departmentTitle" @input="getIDDep" v-on:input="inputLimiterDep"
                 placeholder="Seleccione una opcion">
          <datalist id="posDep">
            <option v-for="dep in posDep" :key="dep.id" :value="dep.title"></option>
          </datalist>
          <button type="submit" @click.prevent="regJoT">Registrar</button>
        </form>
      </div>

      <div v-if="editingJoT">
        <h2>Editar puesto de trabajo</h2>
        <form class="Form">
          <label>Titulo</label>
          <input type="text" v-model="editingJoT.title" v-on:input="inputLimiterTitleEdit"
                 placeholder="Titulo del puesto de trabajo">
          <label>Codigo de Puesto</label>
          <input disabled type="text" v-model="editingJoT.code" @input="inputLimiterCode"
                 placeholder="Codigo del puesto">
          <label>Departamento</label>
          <input list="posDep" v-model="editingJoT.departmentTitle" @input="getIDDepEdit"
                 v-on:input="inputLimiterDepEdit" placeholder="Seleccione una opcion">
          <datalist id="posDep">
            <option v-for="dep in posDep" :key="dep.id" :value="dep.title"></option>
          </datalist>
          <button type="submit" @click.prevent="regChangesJoT">Guardar Cambios</button>
          <button type="submit" @click.prevent="cancelEdit">Cancelar</button>
        </form>
      </div>

    </div>
  </div>


</template>

<style scoped>

</style>